"use client";

import * as React from "react";
import { ArrowRight, MessageSquare, Phone, ShieldCheck, MapPin, Clock, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactTeaser() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169346" id="request-a-quote" className="w-full py-16 !bg-[rgba(245,245,245,1)] md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="max-w-5xl mx-auto overflow-hidden border-secondary-700/50 bg-secondary-800/40 backdrop-blur-md shadow-2xl p-0">
            <div className="grid md:grid-cols-5 lg:grid-cols-3">
              <div className="md:col-span-3 lg:col-span-2 p-8 md:p-12 lg:p-16 flex flex-col justify-center">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/20 text-primary text-xs font-bold uppercase tracking-widest mb-6 w-fit">
                  <MessageSquare className="size-3.5" />
                  <span>Available 24/7</span>
                </div>
                
                <h2 className="text-4xl font-bold tracking-tight mb-6 uppercase leading-[0.9] !text-left !text-[hsl(137,66%,31%)] !font-sans md:text-6xl">READY TO FIX YOUR GARAGE DOOR</h2>
                
                <p className="text-lg text-secondary-200/80 mb-10 max-w-xl leading-relaxed font-sans">Veteran-owned professional precision in every repair and installation. From Splendora to Humble, Schaefer Garage Doors provides free estimates and same-day service for all residential and commercial needs.</p>

                <div className="grid grid-cols-2 gap-y-6 gap-x-8 mb-10">
                  <div className="flex items-center gap-3 group">
                    <div className="p-2 rounded-md bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors">
                      <ShieldCheck className="size-4 text-primary" />
                    </div>
                    <span className="text-[10px] md:text-xs font-bold text-secondary-200 uppercase tracking-widest">Veteran Owned</span>
                  </div>
                  <div className="flex items-center gap-3 group">
                    <div className="p-2 rounded-md bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors">
                      <MapPin className="size-4 text-primary" />
                    </div>
                    <span className="text-[10px] md:text-xs font-bold text-secondary-200 uppercase tracking-widest">Locally Owned</span>
                  </div>
                  <div className="flex items-center gap-3 group">
                    <div className="p-2 rounded-md bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors">
                      <Clock className="size-4 text-primary" />
                    </div>
                    <span className="text-[10px] md:text-xs font-bold text-secondary-200 uppercase tracking-widest">Emergency Dispatch</span>
                  </div>
                  <div className="flex items-center gap-3 group">
                    <div className="p-2 rounded-md bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors">
                      <Zap className="size-4 text-primary" />
                    </div>
                    <span className="text-[10px] md:text-xs font-bold text-secondary-200 uppercase tracking-widest">Same Day Service</span>
                  </div>
                </div>
                
                <div className="grid sm:grid-cols-2 gap-4">
                  {}
                  <Button asChild className="h-auto px-4 py-2 justify-start rounded-md shadow-lg hover:scale-[1.02] transition-all bg-primary text-primary-foreground font-medium">
                    <Link to="tel:713-304-4798">
                      <Phone className="size-5 shrink-0" />
                      <div className="flex flex-col items-start">
                        <p className="text-sm font-bold uppercase tracking-tight">Call 713-304-4798</p>
                        <p className="text-[10px] text-primary-foreground/70 uppercase tracking-wider">Emergency Dispatch</p>
                      </div>
                    </Link>
                  </Button>
                  
                  {}
                  <Button asChild className="h-auto px-4 py-2 justify-start rounded-md shadow-lg hover:scale-[1.02] transition-all bg-primary text-primary-foreground font-medium">
                    <Link to="sms:713-304-4798">
                      <MessageSquare className="size-5 shrink-0" />
                      <div className="flex flex-col items-start">
                        <p className="text-sm font-bold uppercase tracking-tight">Text Us Now</p>
                        <p className="text-[10px] text-primary-foreground/70 uppercase tracking-wider">Fast Response Quotes</p>
                      </div>
                    </Link>
                  </Button>
                </div>
              </div>
              
              <div className="md:col-span-2 lg:col-span-1 bg-secondary-900/60 backdrop-blur-lg p-8 md:p-12 flex flex-col justify-center items-center text-center border-t md:border-t-0 md:border-l border-secondary-700/50">
                <div className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-xl px-6 py-3 font-semibold transition-all duration-300">
                  <ArrowRight className="size-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-3 uppercase tracking-tight !font-sans !text-[hsl(210,9%,31%)]">GET YOUR FREE QUOTE</h3>
                <h4 className="text-primary uppercase tracking-[0.2em] mb-2 !font-semibold !text-lg">FAST ONLINE ESTIMATES</h4>
                <p className="text-sm text-secondary-200/70 mb-10 leading-relaxed max-w-[240px]">Visit our contact page to upload photos of your damage and receive a estimate within hours.</p>
                {}
                <Button size="lg" asChild className="bg-primary text-primary-foreground rounded-md px-4 py-2 font-medium transition-all duration-300">
                  <Link to="https://schaefergaragedoors.com/contact-us/">
                    CONTACT US NOW
                  </Link>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}